import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

// Nach einem neuen Deploy zeigen alte Browser-Tabs auf nicht mehr vorhandene
// Dateien. In diesem Fall die Seite einmalig neu laden statt weisser Bildschirm.
const RELOAD_KEY = "chunk_reload_at";
const isChunkError = (msg?: string) =>
  !!msg && /dynamically imported module|Importing a module script failed|Loading chunk/i.test(msg);

const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  if (Date.now() - last < 10000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener("error", (e) => {
  if (isChunkError(e.message)) reloadOnce();
});
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError((e.reason as Error)?.message)) reloadOnce();
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

